import {
  faFileAudio,
  faFileCode,
  faFileCsv,
  faFileExcel,
  faFileGif,
  faFileJpg,
  faFileLines,
  faFileMov,
  faFileMp3,
  faFileMp4,
  faFilePdf,
  faFilePng,
  faFilePowerpoint,
  faFileText,
  faFileVideo,
  faFileWaveform,
  faFileWord,
  IconDefinition,
} from "@fortawesome/pro-light-svg-icons";

export enum PossibleFileTypesEnum {
  video = "video",
  audio = "audio",
  jpeg = "jpeg",
  jpg = "jpg",
  png = "png",
  gif = "gif",
  pdf = "pdf",
  doc = "doc",
  docx = "docx",
  xls = "xls",
  xlsx = "xlsx",
  pptx = "pptx",
  html = "html",
  txt = "txt",
  csv = "csv",
  mp3 = "mp3",
  wav = "wav",
  mp4 = "mp4",
  avi = "avi",
  mov = "mov",
  zip = "zip",
  md = "md",
  json = "json",
  xml = "xml",
}

export interface IFileType {
  labelKey: string;
  value: string;
  icon: IconDefinition;
}

export const possibleFileTypes = {
  [PossibleFileTypesEnum.video]: {
    labelKey: PossibleFileTypesEnum.video,
    value: "video/*",
    icon: faFileVideo,
  },
  [PossibleFileTypesEnum.audio]: {
    labelKey: PossibleFileTypesEnum.audio,
    value: "audio/*",
    icon: faFileAudio,
  },
  [PossibleFileTypesEnum.jpeg]: {
    labelKey: PossibleFileTypesEnum.jpeg,
    value: "image/jpeg",
    icon: faFileJpg,
  },
  [PossibleFileTypesEnum.jpg]: {
    labelKey: PossibleFileTypesEnum.jpg,
    value: "image/jpeg",
    icon: faFileJpg,
  },
  [PossibleFileTypesEnum.png]: {
    labelKey: PossibleFileTypesEnum.png,
    value: "image/png",
    icon: faFilePng,
  },
  [PossibleFileTypesEnum.gif]: {
    labelKey: PossibleFileTypesEnum.gif,
    value: "image/gif",
    icon: faFileGif,
  },
  [PossibleFileTypesEnum.pdf]: {
    labelKey: PossibleFileTypesEnum.pdf,
    value: "application/pdf",
    icon: faFilePdf,
  },
  [PossibleFileTypesEnum.doc]: {
    labelKey: PossibleFileTypesEnum.doc,
    value: "application/msword",
    icon: faFileWord,
  },
  [PossibleFileTypesEnum.docx]: {
    labelKey: PossibleFileTypesEnum.docx,
    value: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    icon: faFileWord,
  },
  [PossibleFileTypesEnum.xls]: {
    labelKey: PossibleFileTypesEnum.xls,
    value: "application/vnd.ms-excel",
    icon: faFileExcel,
  },
  [PossibleFileTypesEnum.xlsx]: {
    labelKey: PossibleFileTypesEnum.xlsx,
    value: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    icon: faFileExcel,
  },
  [PossibleFileTypesEnum.pptx]: {
    labelKey: PossibleFileTypesEnum.pptx,
    value: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    icon: faFilePowerpoint,
  },
  [PossibleFileTypesEnum.html]: {
    labelKey: PossibleFileTypesEnum.html,
    value: "text/html",
    icon: faFileCode,
  },
  [PossibleFileTypesEnum.txt]: {
    labelKey: PossibleFileTypesEnum.txt,
    value: "text/plain",
    icon: faFileText,
  },
  [PossibleFileTypesEnum.csv]: {
    labelKey: PossibleFileTypesEnum.csv,
    value: "text/csv",
    icon: faFileCsv,
  },
  [PossibleFileTypesEnum.mp3]: {
    labelKey: PossibleFileTypesEnum.mp3,
    value: "audio/mpeg",
    icon: faFileMp3,
  },
  [PossibleFileTypesEnum.wav]: {
    labelKey: PossibleFileTypesEnum.wav,
    value: "audio/wav",
    icon: faFileWaveform,
  },
  [PossibleFileTypesEnum.mp4]: {
    labelKey: PossibleFileTypesEnum.mp4,
    value: "video/mp4",
    icon: faFileMp4,
  },
  [PossibleFileTypesEnum.avi]: {
    labelKey: PossibleFileTypesEnum.avi,
    value: "video/x-msvideo",
    icon: faFileVideo,
  },
  [PossibleFileTypesEnum.mov]: {
    labelKey: PossibleFileTypesEnum.mov,
    value: "video/quicktime",
    icon: faFileMov,
  },
  [PossibleFileTypesEnum.zip]: {
    labelKey: PossibleFileTypesEnum.zip,
    value: "application/zip",
    icon: faFileCode,
  },
  [PossibleFileTypesEnum.md]: {
    labelKey: PossibleFileTypesEnum.md,
    value: "text/markdown",
    icon: faFileLines,
  },
  [PossibleFileTypesEnum.json]: {
    labelKey: PossibleFileTypesEnum.json,
    value: "application/json",
    icon: faFileLines,
  },
  [PossibleFileTypesEnum.xml]: {
    labelKey: PossibleFileTypesEnum.xml,
    value: "application/xml",
    icon: faFileLines,
  },
} as const satisfies Record<PossibleFileTypesEnum, IFileType>;
